import { Theme, makeStyles } from '@material-ui/core';

import { colors } from '../../../assets';

interface Props {
  isShowScrollToTop?: boolean;
}

export const useStyles = makeStyles<Theme, Props>(theme => ({
  backButton: {
    margin: '-8px -16px',
  },
  arrowBackContainer: {
    display: 'flex',
    marginRight: '4px',
    transition: 'all 0.3s',
    transform: ({ isShowScrollToTop }) => (isShowScrollToTop ? 'rotate(90deg)' : ''),
  },
  backTextContainer: {
    textAlign: 'left',
  },
  backText: {
    fontSize: '20px',
    letterSpacing: '0.22px',
    color: colors.grey100,
  },
  closeButton: {
    margin: '-12px',
  },
}));
